<ng-container *transloco="let t;">
  <form (submit)="onSubmit()" novalidate *ngIf="ac !== null">

    <div class="p-grid">
      <div class="p-col-6">
          <h2 *ngIf="inEdit !== true">{{ t('common.labels.onlinetests') }}</h2>
          <h2 *ngIf="inEdit === true && editOnlinetest !== null">{{ t('common.labels.onlinetest') }} {{editOnlinetest.fullname}}</h2>
          <h2 *ngIf="inEdit === true && editOnlinetest === null">{{ t('common.labels.create_onlinetest') }}</h2>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="ac.not_yet_started && inEdit !== true">
        <button withRight="admin.ac.edit" pButton (click)="onNew()" type="button" label="{{ t('common.labels.new') }}" icon="pi pi-plus" class="p-button-sm p-button-success p-mb-2 autofocus"></button>
      </div>
      <div class="p-col-6 p-text-right" *ngIf="inEdit === true">
        <app-form-buttons [submitting]="submitting" (cancelled)="onCancel()"></app-form-buttons>
      </div>
    </div>

    <p-table *ngIf="inEdit !== true && ac.onlinetests.length > 0" [value]="ac.onlinetests">
      <ng-template pTemplate="header">
        <tr>
            <th>{{ t('common.labels.onlinetest') }}</th>
            <th>{{ t('common.labels.type') }}</th>
            <th style="width: 40%">{{ t('common.labels.reports') }}</th>
            <th></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-onlinetest let-index="rowIndex">
        <tr *ngIf="onlinetest.type !== 'normal'">
          <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ onlinetest: onlinetest }"></ng-template>
        </tr>
        <tr *ngIf="onlinetest.type === 'normal'" [pReorderableRow]="index">
          <ng-template [ngTemplateOutlet]="row" [ngTemplateOutletContext]="{ onlinetest: onlinetest }"></ng-template>
        </tr>
      </ng-template>

    </p-table>

    <!-- ROW TEMPLATE -->
    <ng-template #row let-onlinetest="onlinetest">
      <td>{{ onlinetest.partner?.name }}<br>{{ onlinetest.name }}</td>
      <td>
        {{ t(onlinetest.getTypeName()) }}
      </td>
      <td class="reports">
        <div class="p-grid p-mt-1 p-mb-2" *ngFor="let candidate of onlinetest.candidates">
          <ng-container *ngIf="onlinetest.candidates?.length > 1">
            <div class="p-col-9 no-paddings candidate-name">
              {{ getCandidateName(candidate.hashed_id) + ':' | anonymizedCandidate }}
            </div>
            <div *ngIf="canSeeReports()" class="p-col-3 no-paddings candidate-name p-text-right">
              <a *ngIf="!ac.isCancelled() && ac.is_ac === true" class="pointer" (click)="onUploadReport(candidate)"><fa-icon [icon]="faUpload"></fa-icon></a>
            </div>
          </ng-container>
          <ng-container *ngIf="canSeeReports()">
            <ng-container *ngFor="let resource of candidate.resources">
              <div class="p-col-9 p-pl-4 no-paddings">
                <a class="pointer" (click)="onDownloadReport(candidate, resource)">{{ resource.public_name }}</a>
              </div>
              <div class="p-col-3 no-paddings p-text-right">
                <a class="pointer p-ml-2" (click)="onDownloadReport(candidate, resource)"><fa-icon [icon]="faDownload"></fa-icon></a>
                <a class="pointer p-ml-2" (click)="onDeleteReport(candidate, resource)"><fa-icon [icon]="faTrash"></fa-icon></a>
              </div>
            </ng-container>
          </ng-container>
          <div *ngIf="candidate.resources?.length === 0" class="p-col-12">
            <span class="no-report">{{ t('common.labels.no_reports') }}</span>
            <a class="pointer p-ml-2" (click)="onSendReminder(candidate)"><fa-icon [icon]="faEnvelope" [pTooltip]="t('common.labels.send_reminder')"></fa-icon></a>
          </div>
          <div *ngIf="candidate.resources?.length > 0 && !canSeeReports()" class="no-report p-col-12">{{ candidate.resources?.length }} {{ t('common.labels.reports') }}</div>
        </div>
      </td>
      <td style="text-align: right">
        <span withRight="admin.ac.edit" *ngIf="inEdit !== true">
          <button *ngIf="!ac.isCancelled() && ac.is_ac === true && onlinetest.candidates?.length === 1" pButton (click)="onUploadReport(onlinetest.candidates[0])" type="button" icon="pi pi-upload" class="p-button-outlined"></button>
          <button *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onEdit(onlinetest)" type="button" icon="pi pi-pencil" class="p-ml-2"></button>
          <button *ngIf="ac.not_yet_started || ac.is_template" pButton (click)="onDelete(onlinetest)" type="button" icon="pi pi-trash" class="p-button-outlined danger-button p-ml-2" [disabled]="!onlinetest.pivot.deletable"></button>
        </span>
      </td>
    </ng-template>
    <!-- ROW TEMPLATE -->

    <ng-container *ngIf="inEdit === true">

      <h3>{{ t('ac_onlinetests.data_for_onlinetests') }}</h3>
      <div class="p-grid p-fluid">
        <div class="p-col-3">
          <app-form-control [cid]="'onlinetest'" [control]="form.get('onlinetest')" [type]="'cascade'" [options]="optionsPartners" [optionLabel]="'name'" [optionGroupLabel]="'name'" [optionGroupChildren]="['onlinetests']" [label]="t('common.labels.onlinetest')"></app-form-control>
        </div>
        <div class="p-col-3">
          <app-form-control [cid]="'type'" [control]="form.get('type')" [type]="'select'" [options]="optionsTypes" [label]="t('common.labels.type')"></app-form-control>
        </div>
        <div class="p-col-3" *ngIf="isBefore()">
          <app-form-control [cid]="'unlock_days'" [control]="form.get('unlock_days')" [type]="'input'" [label]="t('common.labels.forerun_days')"></app-form-control>
        </div>
        <div class="p-col-3" *ngIf="isDuringAc()">
          <app-form-control [cid]="'duration'" [control]="form.get('duration')" [type]="'input'" [label]="t('common.labels.duration_min')"></app-form-control>
        </div>
        <div class="p-col-3" *ngIf="isDuringAc()">
          <app-form-control [cid]="'rating_duration'" [control]="form.get('rating_duration')" [type]="'input'" [label]="t('common.labels.duration_rating_min')"></app-form-control>
        </div>
      </div>

      <hr />

      <h3>{{ t('ac_onlinetests.dial_in_data') }}</h3>

      <div class="p-grid p-fluid">
        <div class="p-col-12" *ngIf="ac.isGroupAc() && editOnlinetest?.api_active !== true">
          <app-form-control [cid]="'generalized'" [control]="form.get('generalized')" [type]="'checkbox'" [label]="t('common.labels.apply_for_all')"></app-form-control>
        </div>
        <ng-container *ngIf="!ac.isGroupAc() || !isGeneralized()">
          <ng-container *ngFor="let candidate of candidates">
            <div class="p-col-3">
              <div class="p-mt-4">{{ candidate.fullname }}</div>
            </div>
            <div class="p-col-9">
              <div class="p-grid">
                <div class="p-col-3">
                  <app-form-control [cid]="'login_url_' + candidate.id" [control]="candidate.url" [type]="'input'" [label]="t('common.labels.url_onlinetest')" [noMargin]="true"></app-form-control>
                </div>
                <div class="p-col-3">
                  <app-form-control [cid]="'login_user_' + candidate.id" [control]="candidate.user" [type]="'input'" [label]="t('common.labels.login')" [noMargin]="true"></app-form-control>
                </div>
                <div class="p-col-3">
                  <app-form-control [cid]="'login_password_' + candidate.id" [control]="candidate.password" [type]="'input'" [label]="t('common.labels.password')" [noMargin]="true"></app-form-control>
                </div>
                <div class="p-col-3">
                  <app-form-control [cid]="'comment_' + candidate.id" [control]="candidate.comment" [type]="'input'" [label]="t('common.labels.comment')" [noMargin]="true"></app-form-control>
                </div>
              </div>
              <ng-container *ngIf="form.get('onlinetest').value && form.get('onlinetest').value.api_active === true && candidate.overrule?.value !== true">
                <p>
                  <span *ngIf="!candidate.url?.value">{{ t('ac_onlinetests.access_data_restricted_from_api_1') }}</span>
                  <span *ngIf="candidate.url?.value">{{ t('ac_onlinetests.access_data_restricted_from_api_2') }}</span>
                    <a href="javascript:;" (click)="onToggleOverrule(candidate)">{{ t('common.labels.overwrite')}}</a></p>
              </ng-container>
            </div>
          </ng-container>
        </ng-container>
      </div>

      <ng-container *ngIf="ac.isGroupAc() && editOnlinetest?.api_active !== true">
        <hr *ngIf="!isGeneralized()" />
        <div class="p-grid p-fluid">
          <div class="p-col-3" *ngIf="isGeneralized()">
            <div class="p-mt-4">{{ t('common.labels.apply_for_all') }}</div>
          </div>
          <div class="p-col-3" *ngIf="!isGeneralized()">
            <div class="p-mt-4">{{ t('common.labels.apply_for_more') }}</div>
          </div>
          <div class="p-col-9">
            <div class="p-grid">
              <div class="p-col-3">
                <app-form-control [cid]="'login_url'" [control]="form.get('login_url')" [type]="'input'" [label]="t('common.labels.url_onlinetest')"></app-form-control>
              </div>
              <div class="p-col-3">
                <app-form-control [cid]="'login_user'" [control]="form.get('login_user')" [type]="'input'" [label]="t('common.labels.login')"></app-form-control>
              </div>
              <div class="p-col-3">
                <app-form-control [cid]="'login_password'" [control]="form.get('login_password')" [type]="'input'" [label]="t('common.labels.password')"></app-form-control>
              </div>
              <div class="p-col-3">
                <app-form-control [cid]="'comment'" [control]="form.get('comment')" [type]="'input'" [label]="t('common.labels.comment')"></app-form-control>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <hr />

      <h3>{{ t('ac_onlinetests.relevant_competences') }}</h3>
      <app-ac-competences *ngIf="editCompetences?.length > 0" [competences]="editCompetences" [hidden]="hiddenCompetences" (changed)="setHiddenCompetences($event)"></app-ac-competences>
      <p *ngIf="editCompetences?.length === 0">{{ t('ac_onlinetests.please_select_onlinetest') }}</p>

    </ng-container>

    <p *ngIf="inEdit !== true && ac.onlinetests.length === 0">{{ t('common.texts.no_onlinetests') }}</p>

  </form>

  <p-dialog header="{{ t('common.labels.upload_reports') }}" [(visible)]="uploadOpened" [draggable]="false" [resizable]="false" modal="true" [style]="{width: '50vw'}">
    <p-fileUpload #upload [showCancelButton]="false" name="myfile[]" multiple="multiple"
      accept=".pdf"
      maxFileSize="10000000" customUpload="true" (uploadHandler)="onUploadFiles($event)"
      chooseLabel="Auswählen" [showUploadButton]="false"
    >
      <ng-template pTemplate="content" let-files>
        <div *ngIf="files.length === 0" style="text-align: center;">{{ t('common.labels.choose_files') }}</div>
      </ng-template>
    </p-fileUpload>

    <p-footer>
      <button *ngIf="submitting !== true" pButton (click)="onStartUpload()" type="button" label="{{ t('common.labels.upload') }}" icon="pi pi-upload" class="p-button-success"></button>
      <button *ngIf="submitting === true" pButton type="button" label="{{ t('common.labels.upload') }}" icon="pi pi-upload" class="p-button-success" disabled="true"></button>
    </p-footer>
  </p-dialog>
</ng-container>
